export const HELP_ARTICLES = {
  dynamicPages: {
    seo: '4c46a5f2-fabb-416e-84b9-7971b56d386b',
  },
}
